Ext.define('SA.AcsTable.DefaultViewController', {
    constructor({
        model,
        projectView,
        loadMask,
        tableData,
        folderData,
        dataMap,
        state,
        grid,
        toolbar,
        tableSearchController
    }) {
        this.model = model;
        this.projectView = projectView;
        this.loadMask = loadMask;
        this.tableData = tableData;
        this.folderData = folderData;
        this.dataMap = dataMap;
        this.state = state;
        this.grid = grid;
        this.toolbar = toolbar;
        this.tableSearchController = tableSearchController;
    },

    loadFolderAttributes() {
        if (!this.state.hasFolderId()) {
            return;
        }

        this.folderData.load({folderId: this.state.getFolderId()});
    },

    loadTableFolders() {
        this.tableData.load({censusReleaseYear: this.state.getCensusReleaseYear(), edition: this.state.getEdition()});
    },

    onDataMapResults() {
        this.refreshGrid();
    },

    onEditionDropdownChange(edition) {
        this.model.setEdition(edition);
        this.model.save();

        this.loadTableFolders();
        this.loadFolderAttributes();

        this.refreshGrid();
        this.refreshTableSearchController();
    },

    onFolderDataResults() {
        this.refreshGridTracks();
    },

    onLocationDragEnd() {
        this.model.setLocationsOrder(this.grid.getTrackIds().getColIds());
    },

    onModelStateResolved() {
        this.refreshGridTracks();
    },

    onProjectViewResize() {
        this.refreshGridContainerSize();
    },

    onShowView() {
        this.showView();
    },

    onTableDataResults() {
        this.loadFolderAttributes();

        this.refreshGrid();
        this.refreshTableSearchController();
    },

    onTableSearchResultItemClick(tableId) {
        this.model.setTableId(tableId);
        this.model.save();

        this.loadFolderAttributes();

        this.refreshGrid();
    },

    refreshGrid() {
        if (this.state.hasAttributes()) {
            this.loadMask.destroy();
            this.grid.render();
            this.grid.hideLoadMask();
            this.toolbar.setLoaded();
        }
        else {
            this.grid.showLoadMask();
            this.toolbar.setLoading();
        }
    },

    refreshGridContainerSize() {
        this.grid.setContainerSize(this.state.getGridContainerSize());
        this.refreshGrid();
    },

    refreshGridTracks() {
        if (!this.state.hasAttributes()) {
            return;
        }

        this.grid.setTrackIds(this.state.getGridTrackIds());
        this.dataMap.autoEnsure(this.state.getDataMapParams());
        this.refreshGrid();
    },

    refreshTableSearchController() {
        if (!this.state.tableFoldersLoaded()) {
            return;
        }

        this.tableSearchController.setData(this.state.getTableFolders());
    },

    showView() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .apply();

        SA.PageHeader.setView(this.model);
        SA.ViewChooser.setView(this.model);
        SA.HistoricalModeIndicator.maybeShow(this.model);
        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        SA.ProjectView.show(this.projectView);

        this.loadTableFolders();

        this.refreshGridTracks();
        this.refreshGridContainerSize();
    }
});